export function toMoney(str, fixedLength = 2) {
    let regExp = /^\D$/g;
    if (!str && str !== 0 || isNaN(str)) {
        return str;
    }
    return parseFloat(str).toFixed(fixedLength).replace(/\d(?=(?:\d{3})+\b)/g, `$&,`);
}